import React, { useState, useEffect } from 'react';
import Toolbar from '@mui/material/Toolbar';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Sidebar from './Sidebar';
import { ArrowBack } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';
import { Description, ThumbUp, SupervisorAccount, Calculate, HouseOutlined, AccountCircle, AddCircleOutline, Logout, Storage, Settings } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { clearAuthData } from '../../store/slices/authSlice';
import { resetLawfirm } from '../../store/slices/lawFirmSlice';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import Fade from '@mui/material/Fade';
import Campaign from '@mui/icons-material/Campaign';
import { apiClient, apiClientRaw } from '../utils/api';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const refreshToken = useSelector((state) => state.auth.refreshToken);
  const userdetails = useSelector((state) => state.auth.user);
  const userType = useSelector((state) => state.auth.role);
  const pg_id = useSelector((state) => state.auth.pg_id);

  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const [loggingOut, setLoggingOut] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [fullName, setFullName] = useState('');
  const [showTerms, setShowTerms] = useState(false);
  const [tab, setTab] = useState(0);
  const [appData, setAppData] = useState({
    user: { firstName: "", lastName: "" },
    logoSrc: "/logo.png",
    avatarSrc: "/Probate.jpeg",
    home: '/',
  });

  // Fetch recent announcements from API
  const [announcements, setAnnouncements] = useState([]);
  const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);

  // Add a role to home path map
  const rolePathMap = {
    super_user: '/admin_home',
    internal_user: '/internal_user_home',
    law_firm_user: '/law_firm_user_home',
    law_firm_admin: '/law_firm_admin_home',
    carrier_team_member: '/carrier_team_member_dashboard',
    professional_guardian_user: '/professional_guardian_home',
    pg_contact: '/pg_contact_home',
  };

  useEffect(() => {
    if (userType === 'super_user') {
      setMenuItems([
        { name: 'Home', path: '/admin_home', icon: <HouseOutlined /> },
        { name: 'Account Management', path: '/admin_account_management', icon: <SupervisorAccount /> },
        { name: 'Request a Bond', path: '/bond-creation-outsider', icon: <Description /> },
        { name: 'Approve Bonds', path: '/vermost_approve_bonds', icon: <ThumbUp /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
        { name: 'Data Management', path: '/admin_data_management', icon: <Storage /> },
        { name: 'System Management', path: '/admin_system_management', icon: <Settings /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/admin_home',
      });
    } else if (userType === 'internal_user') {
      setMenuItems([
        { name: 'Home', path: '/internal_user_home', icon: <HouseOutlined /> },
        { name: 'Account Management', path: '/simple_user_account_management', icon: <SupervisorAccount /> },
        { name: 'Request a Bond', path: '/bond-creation-outsider', icon: <Description /> },
        { name: 'Approve Bonds', path: '/vermost_approve_bonds', icon: <ThumbUp /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/internal_user_home',
      });
    }
    else if (userType === 'law_firm_admin') {
      setMenuItems([
        { name: 'Home', path: '/law_firm_admin_home', icon: <HouseOutlined /> },
        { name: 'Request a Bond', path: '/bond-creation-outsider', icon: <Description /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/internal_user_home',
      });
    }
    else if (userType === 'law_firm_user') {
      setMenuItems([
        { name: 'Home', path: '/law_firm_user_home', icon: <HouseOutlined /> },
        { name: 'Request a Bond', path: '/bond-creation-outsider', icon: <Description /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/internal_user_home',
      });
    }
    else if (userType === 'pg_contact') {
      setMenuItems([
        { name: 'Home', path: '/pg_contact_home', icon: <HouseOutlined /> },
        { name: 'Request a Bond', path: '/bond-creation-outsider', icon: <Description /> },
        { name: 'View Bonds', path: `/professional_guardian_view_bonds/${pg_id || ''}`, icon: <ThumbUp /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/pg_contact_home',
      });
    }
    else if (userType === 'carrier_team_member') {
      setMenuItems([
        { name: 'Home', path: '/carrier_team_member_dashboard', icon: <HouseOutlined /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
        { name: 'Enhancement Requests', path: '/create-enhancement-request', icon: <AutoAwesome /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/carrier_team_member_dashboard',
      });
    }
    else {
      setMenuItems([
        { name: 'Home', path: '/professional_guardian_home', icon: <HouseOutlined /> },
        { name: 'Request a Bond', path: '/bond-creation-outsider', icon: <Description /> },
        { name: 'Bond Calculator', path: '/premium_calculator', icon: <Calculate /> },
      ]);
      setAppData({
        logoSrc: "/logo.png",
        avatarSrc: "/Probate.jpeg",
        home: '/internal_user_home',
      });
    }
    setFullName(userdetails.username);
  }, [userType, userdetails.username, pg_id]);

  // Fetch recent announcements from API
  useEffect(() => {
    const fetchRecentAnnouncements = async () => {
      try {
        setLoadingAnnouncements(true);
        const response = await apiClient('/announcements-recent/', 'GET');
        const announcementsData = response.data || [];
        // Map API data to match the format expected by the UI
        const formattedAnnouncements = announcementsData.map((ann) => ({
          id: ann.announcement_id,
          title: ann.heading,
          body: ann.description,
          type: ann.type,
          created_at: ann.created_at,
        }));
        setAnnouncements(formattedAnnouncements);
      } catch (error) {
        console.error('Failed to fetch recent announcements:', error);
        // Fallback to empty array if fetch fails
        setAnnouncements([]);
      } finally {
        setLoadingAnnouncements(false);
      }
    };
    fetchRecentAnnouncements();
  }, []);

  // Rotate announcements on an interval
  useEffect(() => {
    if (!announcements || announcements.length <= 1) return;
    const intervalId = setInterval(() => {
      setCurrentAnnouncementIndex((prev) => (prev + 1) % announcements.length);
    }, 6000);
    return () => clearInterval(intervalId);
  }, [announcements]);

  const handleOpenAnnouncement = (announcement) => {
    setSelectedAnnouncement(announcement);
    setShowAnnouncement(true);
  };

  const handleCloseAnnouncement = () => {
    setShowAnnouncement(false);
    // Do not clear selectedAnnouncement to keep content for transition close
  };

  // Flash success banner after navigation (e.g., bond created)
  const [flashBanner, setFlashBanner] = useState(null);
  useEffect(() => {
    const raw = sessionStorage.getItem('flashToast');
    if (!raw) return;
    sessionStorage.removeItem('flashToast');
    try {
      const { message, link } = JSON.parse(raw);
      setFlashBanner({ message, link });
    } catch (_) {
      // ignore malformed flash
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!flashBanner) return;
    const t = setTimeout(() => setFlashBanner(null), 5000);
    return () => clearTimeout(t);
  }, [flashBanner]);

  const handleToggleUserMenu = (event) => {
    setUserMenuAnchorEl(userMenuAnchorEl ? null : event.currentTarget);
  };

  const handleLogout = async () => {
    setLoggingOut(true);
    navigate('/');
    toast.success('Logged out successfully.');
    dispatch(clearAuthData());
    dispatch(resetLawfirm());
    localStorage.removeItem('accessToken');
    localStorage.removeItem('lastVisitedPath');

    try {
      await apiClientRaw('/logout/', 'POST', { refresh: refreshToken });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setLoggingOut(false);
    }
  };

  const handleGoBackOrClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      window.close();
    }
  };

  const handleViewTerms = () => {
    setTab(0);
    setShowTerms(true);
    setUserMenuAnchorEl(null);
  };

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: "white", borderBottom: "1px solid #ddd" }}>
      <Toolbar className='border-b-2 border-gray-100'>
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
          <Box display="flex" alignItems="center" sx={{ flexBasis: 'auto' }}>
            <IconButton onClick={handleGoBackOrClose} color="inherit" sx={{ mr: 1 }}>
              <ArrowBack />
            </IconButton>
            <Box sx={{ mr: 1 }}>
              <Sidebar menuItems={menuItems} />
            </Box>
            <Box onClick={() => navigate(rolePathMap[userType] || '/')} bgcolor="white" alignItems='center' height='10%' sx={{ ml: 1 }}>
              <img src={appData.avatarSrc} alt="Logo" style={{ maxWidth: '40%', height: '40%' }} />
            </Box>
          </Box>

          <Box display="flex" gap={1} alignItems="center">
            {/* What's New ticker - only show if announcements exist */}
            {!loadingAnnouncements && announcements.length > 0 && (
              <Tooltip title="Click to read more" arrow>
                <Box
                  onClick={() => handleOpenAnnouncement(announcements[currentAnnouncementIndex])}
                  sx={{
                    display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                    maxWidth: 520,
                    px: 1.5,
                    py: 0.75,
                    mr: 1,
                    bgcolor: '#f7f9ff',
                    border: '1px solid #e6eaf2',
                    borderRadius: 999,
                    boxShadow: 0,
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease',
                    '&:hover': { bgcolor: '#f0f5ff' },
                  }}
                >
                  <Campaign sx={{ color: '#1d4ed8', fontSize: 18, mr: 1 }} />
                  <Fade in key={currentAnnouncementIndex} timeout={500}>
                    <Typography
                      variant="body2"
                      noWrap
                      sx={{ color: '#0f172a', maxWidth: 420 }}
                    >
                      <Box component="span" sx={{ fontWeight: 700 }}>
                        {announcements[currentAnnouncementIndex]?.title}:
                      </Box>{' '}
                      {announcements[currentAnnouncementIndex]?.body}
                    </Typography>
                  </Fade>
                  <Typography variant="caption" sx={{ ml: 1, color: '#2563eb', fontWeight: 700 }}>
                    Read more
                  </Typography>
                </Box>
              </Tooltip>
            )}
            <IconButton sx={{ p: 0 }} onClick={handleToggleUserMenu}>
              <Avatar alt="User" sx={{ width: 40, height: 40 }} />
            </IconButton>
            <Typography variant="body1" fontFamily={'sans-serif'} fontWeight={'500'}>{fullName}</Typography>
            <IconButton sx={{ p: 0 }} onClick={handleToggleUserMenu}>
              <ArrowDropDownIcon />
            </IconButton>
            <Menu
              anchorEl={userMenuAnchorEl}
              open={Boolean(userMenuAnchorEl)}
              onClose={() => setUserMenuAnchorEl(null)}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  minWidth: 250,
                  boxShadow: 3,
                  mt: 1,
                },
              }}
            >
              <MenuItem onClick={() => navigate('/profile')}>
                <ListItemIcon>
                  <AccountCircle fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Profile" />
              </MenuItem>

              <MenuItem onClick={handleViewTerms}>
                <ListItemIcon>
                  <Description fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="View Terms & Conditions" />
              </MenuItem>

              <MenuItem onClick={() => navigate('/create-enhancement-request')}>
                <ListItemIcon>
                  <AddCircleOutline fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Submit Enhancement Request" />
              </MenuItem>

              <MenuItem onClick={handleLogout} disabled={loggingOut}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                {loggingOut ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={18} />
                    <Typography variant="inherit">Signing Out...</Typography>
                  </Box>
                ) : (
                  <ListItemText primary="Sign Out" />
                )}
              </MenuItem>
            </Menu>

          </Box>
        </Box>
      </Toolbar>
      {flashBanner && (
        <Box
          sx={{
            width: '100%',
            bgcolor: '#22c55e', // subtle green
            color: 'white',
            py: 1.25,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ fontWeight: 600 }}>{flashBanner.message}</Typography>
          {flashBanner.link && (
            <Button
              variant="text"
              sx={{ color: 'white', textDecoration: 'underline', fontWeight: 700 }}
              onClick={() => navigate(flashBanner.link)}
            >
              View Details →
            </Button>
          )}
        </Box>
      )}

      {/* Announcement detail dialog */}
      <Dialog
        open={showAnnouncement}
        onClose={handleCloseAnnouncement}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { borderRadius: '16px', padding: '10px' } }}
      >
        <DialogTitle sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Campaign sx={{ color: '#1d4ed8' }} />
          {selectedAnnouncement?.title || "What's New"}
        </DialogTitle>
        <Divider />
        <DialogContent dividers sx={{ backgroundColor: '#fafafa' }}>
          <Typography variant="body1" sx={{ mb: 2, color: '#0f172a' }}>
            {selectedAnnouncement?.body}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-end', p: 2 }}>
          <Button onClick={handleCloseAnnouncement} variant="outlined" color="inherit">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showTerms}
        onClose={() => setShowTerms(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
        PaperProps={{ style: { borderRadius: '16px', padding: '10px' } }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Website Terms of Use</DialogTitle>
        <Divider />
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Website Terms of Use" />
          <Tab label="Privacy Policy" />
        </Tabs>
        <DialogContent
          dividers
          sx={{ height: '70vh', p: 2, backgroundColor: '#fafafa' }}
        >
          {tab === 0 && (
            <iframe
              src="/toc.pdf"
              title="Terms of Use PDF"
              style={{ width: '100%', height: '100%', border: 'none', borderRadius: '4px' }}
            />
          )}
          {tab === 1 && (
            <iframe
              src="/ccpa.pdf"
              title="Privacy Policy PDF"
              style={{ width: '100%', height: '100%', border: 'none', borderRadius: '4px' }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-end', p: 2 }}>
          <Button onClick={() => setShowTerms(false)} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Navbar;